import React from 'react'
import { useExercise } from '../ExerciseProvider'
import { Label } from '~/lib/ui/label'
import { useVitalityExercise } from './VitalityExerciseProvider'

const VitalityExercisePageTwo = () => {
  const { rankedPoints, pageTwoTranslations } = useVitalityExercise()
  const topFivePoints = rankedPoints
    .filter((point) => point.rank !== null)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 5)

  const { instructions, text_box_label } = pageTwoTranslations

  return (
    <div>
      <div>
        <ol className="list-decimal pl-6">
          {topFivePoints.map((point, index) => (
            <li
              key={`top_vitality_point-${index}`}
              className="flex list-decimal items-center gap-2"
            >
              <div className="flex items-center gap-2">{point.name}</div>
            </li>
          ))}
        </ol>
      </div>
      <div className="mt-4 flex flex-col gap-2">
        <div>{instructions}</div>
        <TextArea label={text_box_label} />
      </div>
    </div>
  )
}

export default VitalityExercisePageTwo

const TextArea = ({ label }) => {
  const { getResponse, handleChange } = useExercise()

  const handleTextChange = (e) => {
    handleChange(1, 'ideas', e)
  }

  const textResponse = getResponse(1, 'ideas') || ''

  return (
    <div>
      <Label
        htmlFor="vitality-action-ideas"
        className="mb-2 block font-roboto text-base font-bold"
      >
        {label}
      </Label>
      <textarea
        id="vitality-action-ideas"
        className="min-h-[125px] w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
        onChange={handleTextChange}
        value={textResponse}
      />
    </div>
  )
}
